import React from 'react';
import ReactPlayer from 'react-player';

export default function VedioShow(props) {
    return (
        <div className="bam-image">
            <ReactPlayer width="100%" height="90vh" url={props.item.newTag11} playing playsinline controls />
        </div>
    )
}
